var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "133",
        viewBox: "0 0 178 133",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M176.294 0H0V132.463H176.294V0Z", fill: "#E53C6A" },
      }),
      _c("path", {
        attrs: {
          d: "M0 40.507V0H177.149V132.464H122.977C55.059 132.464 0 91.2931 0 40.507Z",
          fill: "#FF567B",
        },
      }),
      _c("path", {
        attrs: {
          d: "M176.295 65.053V0H92.0947C102.931 31.2787 135.138 56.0564 176.295 65.053Z",
          fill: "#E53C6A",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }